import 'what-input'
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'

// Flag JS as active — enables CSS scroll-reveal and logo animation rules
document.documentElement.classList.add('js')

window.Alpine = Alpine

Alpine.plugin(intersect)
Alpine.plugin(focus)

Alpine.start()

// Scroll-reveal: fade-up content sections as they enter the viewport
const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target as HTMLElement
        el.classList.add('is-revealed')
        // Stagger direct children
        Array.from(el.children).forEach((child, i) => {
          ;(child as HTMLElement).style.transitionDelay = `${i * 80}ms`
        })
        revealObserver.unobserve(el)
      }
    })
  },
  { threshold: 0.08, rootMargin: '0px 0px -40px 0px' },
)

document.querySelectorAll<HTMLElement>(
  '.basicCopy > .relative, .twoColumnContent > .relative, .heading > .relative, .newsList > .relative, .quote > .relative, .rateTable > .relative, .button > .relative',
).forEach((el) => revealObserver.observe(el))

